"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogWrapper = exports.TitleWrapper = exports.SwitchMenuWrapper = exports.ImageWrapper = exports.Description = exports.DescriptionWrapper = exports.PrimaryRowWrapper = exports.ChildrenWrapper = exports.RoundButtonWrapper = exports.TitleWithoutMenu = exports.Title = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto 6fr 6fr;
  align-items: center;
  background-color: ${colors_1.WHITE};
  position: relative;
  @media (max-width: 687px) {
    justify-items: center;
    align-items: center;
    grid-template-columns: 1fr;
    padding: 0;
    height: fit-content;
  }
`;
exports.Title = styled_components_1.default.h1 `
  grid-column-start: 1;
  font-size: 48px;
  margin: 0;
  padding: 8px 8px 0;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: 1px solid ${colors_1.BLACK};
  }

  @media (max-width: 687px) {
    margin-top: 16px;
  }

  ${({ $active }) => $active && `border: 1px solid ${colors_1.BLACK}`}
`;
exports.TitleWithoutMenu = styled_components_1.default.h1 `
  grid-column-start: 1;
  font-size: 48px;
  margin: 0;
  @media (max-width: 687px) {
    margin-top: 16px;
  }
`;
exports.RoundButtonWrapper = styled_components_1.default.div `
  margin-left: 32px;
  grid-column-start: 2;
  display: flex;
  align-items: flex-start;

  span + button,
  button + button {
    margin-left: 16px;
  }
  @media (max-width: 687px) {
    margin: 8px 0 0 0;
    grid-column-start: 1;
    grid-row-start: 3;

    a {
      display: none;
    }
  }
`;
exports.ChildrenWrapper = styled_components_1.default.div `
  grid-column-start: 3;
  @media (max-width: 687px) {
    grid-column-start: 1;
  }
`;
exports.PrimaryRowWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  grid-column-start: 1;
`;
exports.DescriptionWrapper = styled_components_1.default.div `
  display: flex;
  grid-column-start: 1;
  grid-column-end: -1;
  @media (max-width: 687px) {
    grid-row-start: 2;
    justify-content: center;
    align-items: center;
    margin: 0 8px;
  }
`;
exports.Description = styled_components_1.default.span `
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${colors_1.GREY3};
  @media (max-width: 687px) {
    text-align: center;
  }
`;
exports.ImageWrapper = styled_components_1.default.span `
  grid-column-start: 2;
  margin-left: 32px;

  @media (max-width: 687px) {
    display: none;
  }
`;
exports.SwitchMenuWrapper = styled_components_1.default.div `
  position: absolute;
  z-index: 9;
  left: 0;
  right: 0;
`;
exports.TitleWrapper = styled_components_1.default.div ``;
exports.DialogWrapper = styled_components_1.default.div `
  position: relative;
  z-index: 9999;

  & > div > div + div {
    width: 75dvw;
    max-width: 1150px;

    > div:first-child > div > div {
      margin-left: 0;
      padding-left: 0;
      @media (min-width: 689px) {
        font-size: 24px;
      }
    }
  }

  @media (max-width: 1199px) {
    & > div > div + div {
      width: 80dvw;
      top: 46%;
      padding: 16px;
    }
  }
`;
//# sourceMappingURL=SubHeader.styles.js.map